import * as React from 'react';
import SCBLogo from '../assets/Icons/logo.svg';
import Arrow from '../assets/Icons/arrow.svg';
import { CSSProperties, MouseEventHandler } from 'react';
import { colors } from '../colors';
import Sticky from './sticky/Sticky';
import { useDivSize } from '../hoc/useDivSizeHOC';
import useResizeAware from 'react-resize-aware';
import { ArrowDown } from './ArrowDown';
import * as Scroll from 'react-scroll';
import { isMobile, mediaQueries } from '../mediaQueries';

interface IProps {
    height: number;
    // onStickyHeight: (h: number) => void;
    headerPageScroll: string;

}


export const Header = ({ height, headerPageScroll }: IProps) => {

    const [sticky, setSticky] = React.useState(false);
    // const initialTop = React.useRef<number | undefined>()
    // const [logoW, setLogoW] = React.useState(InitialWidthPercentage)
    // const [resizeListener, sizes] = useResizeAware();

    // React.useEffect(() => {
    //     onStickyHeight(sizes.height);
    // }, [sizes]);


    const onStickyChange = (isSticky: boolean) => {
        // console.info('onStickyChange', isSticky);
        setSticky(isSticky);
    }

    // const onStickyTopChange = (realTop: number) => {

    //     if (!initialTop.current) {
    //         initialTop.current = realTop;
    //     }
    // }


    const onArrowClick = () => {
        Scroll.scroller.scrollTo(headerPageScroll, {
            duration: 1000,
            delay: 50,
            smooth: true,
        });
    }

    const onLogoClick: MouseEventHandler<any> = e => {
        e.preventDefault();
        e.stopPropagation();
    }

    return (<div className="header-container" style={{ height: height - 80, display: 'flex', flexDirection: 'column', }}>
        <div style={{ flex: 1 }} />
        <Sticky onChange={onStickyChange} containerClassName="header-sticky-container">
            {isSticky => (<div className="react-header">
                {/* {resizeListener} */}
                <a href={location.href} target="_self" onClick={onLogoClick}><img className={sticky ? 'sticky' : 'not-sticky'} src={SCBLogo} /></a>
            </div>)}
        </Sticky>
        <div className="centered flex2">
            <h1 className="red-color">
                Diamo credito al <span style={{ marginLeft: 10 }}>
                    <b>cambiamento</b>
                </span>
            </h1>

            <p className="red-color" style={{ maxWidth: '80%' }}>Scopri il cambiamento a portata di click </p>
        </div>
        <div className="arrow-bottom-container header">
            <ArrowDown big={true} color={'red'} onClick={onArrowClick} />
        </div>
    </div>)
}